import React, { useState, useRef } from "react";
import "./Careers.css"; 
// import Careerimg from "../Assessts/Carrer4.png";
// import Careerimg from "../Assessts/Carrer3.jpg";
// import Careerimg from "../Assessts/carrer.png";
import Careerimg from "../Assessts/carrer1.jpg";
// import Careerimg from "../Assessts/carrer2.png";

const Careers = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    position: "",
    experience: "",
    file: null,
  });

  const [alertMsg, setAlertMsg] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const fileInputRef = useRef(null); // REF for file input

  const handleChange  = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setFormData({ ...formData, file: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show alert
    setAlertMsg("✅ Application submitted successfully!");
    setShowAlert(true);

    // Reset form fields
    setFormData({
      name: "",
      email: "",
      position: "",
      experience: "",
      file: null,
    });

    // Reset file input manually
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    // Hide alert after 5 seconds
    setTimeout(() => setShowAlert(false), 5000);
    console.log("Form submitted:", formData);
  };
// #155382ff
  return (
    <div>
      {/* Hero Image */}
      <div style={{ position: "relative", width: "100%", height: "400px", overflow: "hidden" }}>
        <img src={Careerimg} alt="Careers" style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(100%)" }} />
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "white", textAlign: "center" }}>
          <h1 style={{ fontSize: "48px", fontWeight: "bold" }}>Careers</h1>
          <p><span style={{ color: "#fff" }}>Home</span> <span style={{ color: "white" }}>/ Careers</span></p>
        </div>
      </div>

      {/* Alert */}
      <div style={{
        position: "fixed",
        top: showAlert ? "20px" : "-60px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#d4edda",
        color: "#155724",
        padding: "15px 30px",
        fontWeight: "bold",
        borderRadius: "5px",
        transition: "top 0.5s ease-in-out",
        zIndex: 1000,
      }}>
        {alertMsg}
      </div>

      {/* Form */}
      <div className="career-container">
        <div className="career-card">
          <h1 className="career-title">Careers </h1>
          <p className="career-subtitle">Join our team! Fill the form below and upload your resume.</p>


          <form onSubmit={handleSubmit} className="career-form">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Enter your name" />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Enter your email" />
            </div>

            <div className="form-group">
              <label>Position</label>
              <input type="text" name="position" value={formData.position} onChange={handleChange} required placeholder="Enter the position you are applying for" />
            </div>

            <div className="form-group">
              <label>Work Experience</label>
              <input type="text" name="experience" value={formData.experience} onChange={handleChange} required placeholder="e.g. 3 years in Embedded Systems" />
            </div>

            <div className="form-group">
              <label>Upload Resume</label>
              <input
                type="file"
                name="file"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                ref={fileInputRef} // attach ref here
                required
              />
            </div>

            <button type="submit" className="submit-btn">Submit Application</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Careers;
